import { onMounted, onUnmounted } from "vue";
import { isComponentScope } from "../component";


let addedListeners: any[] = [];

export const useEvent = <K extends keyof WindowEventMap>(name: K, listener: (this: Window, ev: WindowEventMap[K]) => any) => {

  const cancel = () => {
    window.removeEventListener(name, listener);
    addedListeners = addedListeners.filter(it => it !== listener);
  }

  if (isComponentScope()) {
    onMounted(() => {
      if (addedListeners.includes(listener)) return;
      addedListeners.push(listener);
      window.addEventListener(name, listener);
    })

    onUnmounted(() => {
      cancel();
    });
  } else {
    queueMicrotask(() => {
      if (addedListeners.includes(listener)) return;
      addedListeners.push(listener);
      window.addEventListener(name, listener);
    })
  }
}
